import { z } from 'zod';

import { isMoney, type Money } from '@nucleus-commerce/core';

const PERCENT = /^\d{1,3}(\.\d{1,2})?$/;

/** Fixed value in minor units, percent 0–100 (up to two decimals), or no discount at all. */
export const discountSchema = z
  .object({
    type: z.enum(['none', 'fixed', 'percent']),
    amount: z.custom<Money>(isMoney).nullable(),
    percent: z.string().trim(),
    reason: z.string().trim().max(200, { error: 'draftOrders:discount.validation.reason' }),
  })
  .superRefine((v, ctx) => {
    if (v.type === 'fixed' && (v.amount === null || v.amount.amount <= 0)) {
      ctx.addIssue({
        code: 'custom',
        path: ['amount'],
        message: 'draftOrders:discount.validation.amount',
      });
    }
    if (v.type === 'percent') {
      const value = Number(v.percent);
      if (!PERCENT.test(v.percent) || value <= 0 || value > 100) {
        ctx.addIssue({
          code: 'custom',
          path: ['percent'],
          message: 'draftOrders:discount.validation.percent',
        });
      }
    }
  });

export type DiscountFormInput = z.input<typeof discountSchema>;
export type DiscountFormOutput = z.output<typeof discountSchema>;
